/* type information for all variants & any component-specific prop types or enums go in this file */
// type util to create attribute as optional in interface/type

/** Root prop interface */

/** interface for defining a nav menu top level item with menu sub-items */

/** type for defining the active link */
export var SecondaryNavLinkTypes;

(function (SecondaryNavLinkTypes) {
  SecondaryNavLinkTypes["SIGN_IN"] = "SIGN_IN";
  SecondaryNavLinkTypes["FOR_EDUCATOR"] = "FOR_EDUCATOR";
  SecondaryNavLinkTypes["HELP"] = "HELP";
  SecondaryNavLinkTypes["LANGUAGE_SELECTOR"] = "LANGUAGE_SELECTOR";
})(SecondaryNavLinkTypes || (SecondaryNavLinkTypes = {}));